import { render, staticRenderFns } from "./Recent.vue?vue&type=template&id=92001b92&scoped=true"
import script from "./Recent.vue?vue&type=script&lang=js"
export * from "./Recent.vue?vue&type=script&lang=js"
import style0 from "./Recent.vue?vue&type=style&index=0&id=92001b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92001b92",
  null
  
)

export default component.exports